<template>
  <div class="dbs_info">
    <CycleInfo label="ポート名" :value="park.Station.Name" />
    <CycleInfo
      v-if="park.Corporation.code == 'DOCOMO' && park.park_info"
      label="住所"
      :value="park.park_info.park_address"
    />
    <CycleInfo label="事業者" :value="park.Corporation.Name" />
  </div>
</template>

<script>
export default {
  name: "DbsParkInfoUpper",
  props: {
    park: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.dbs_info {
  line-height: 40px;
}
</style>
